import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit'
import { InitialFormValues } from 'src/components/organisms/InvoiceUpdate'
import { InvoiceFormData } from 'src/helpers/invoiceFormValidation'

export interface InvoiceReducer {
  loading: boolean
  error: string | null
  invoice_pdf: string | null
  initialInvoiceValues: Record<string, InitialFormValues>
}

const initialState: InvoiceReducer = {
  loading: false,
  error: null,
  invoice_pdf: null,
  initialInvoiceValues: {}
}

export type CreateInvoiceActionType = PayloadAction<InvoiceFormData>
export const CREATE_INVOICE = createAction<InvoiceFormData>('invoice_reducer/create_invoice')
interface CreateInvoiceSuccessPayload {
  pdf_url: string
}

export const CREATE_INVOICE_SUCCESS = createAction<CreateInvoiceSuccessPayload>(
  'invoice_reducer/create_invoice_success'
)
export const CREATE_INVOICE_FAILURE = createAction('invoice_reducer/create_invoice_failure')

export const RESET_INVOICE_PDF = createAction('invoice_reducer/reset_invoice_pdf')

interface FetchInitialInvoiceValuesPayload {
  id: string
}

export type FetchInitialInvoiceValuesActionType = PayloadAction<FetchInitialInvoiceValuesPayload>

export const FETCH_INITIAL_INVOICE_VALUES = createAction<FetchInitialInvoiceValuesPayload>(
  'invoice_reducer/fetch_initial_invoice_values'
)
interface FetchInitialInvoiceValuesSuccessPayload extends InitialFormValues {
  id: string
}
export const FETCH_INITIAL_INVOICE_VALUES_SUCCESS = createAction<FetchInitialInvoiceValuesSuccessPayload>(
  'invoice_reducer/fetch_initial_invoice_values_success'
)
export const FETCH_INITIAL_INVOICE_VALUES_FAILURE = createAction('invoice_reducer/fetch_initial_invoice_values_failure')

interface UpdateInvoicePayload {
  values: InvoiceFormData
  id: string
}
export type UpdateInvoiceActionType = PayloadAction<UpdateInvoicePayload>
export const UPDATE_INVOICE = createAction<UpdateInvoicePayload>('invoice_reducer/update_invoice')
export const UPDATE_INVOICE_SUCCESS = createAction<CreateInvoiceSuccessPayload>(
  'invoice_reducer/update_invoice_success'
)
export const UPDATE_INVOICE_FAILURE = createAction('invoice_reducer/update_invoice_failure')

export const invoiceReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(CREATE_INVOICE, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(CREATE_INVOICE_SUCCESS, (state, action) => {
      state.loading = false
      state.invoice_pdf = action.payload.pdf_url
      state.error = null
    })
    .addCase(CREATE_INVOICE_FAILURE, (state, action) => {
      state.loading = false
    })
    .addCase(RESET_INVOICE_PDF, (state) => {
      state.invoice_pdf = null
    })
    .addCase(FETCH_INITIAL_INVOICE_VALUES, (state) => {
      state.loading = true
    })
    .addCase(FETCH_INITIAL_INVOICE_VALUES_SUCCESS, (state, action) => {
      state.loading = false
      state.initialInvoiceValues[action.payload.id.toString()] = action.payload
    })
    .addCase(FETCH_INITIAL_INVOICE_VALUES_FAILURE, (state) => {
      state.loading = false
    })
    .addCase(UPDATE_INVOICE, (state) => {
      state.loading = true
    })
    .addCase(UPDATE_INVOICE_SUCCESS, (state, action) => {
      state.invoice_pdf = action.payload.pdf_url
      state.loading = false
    })
    .addCase(UPDATE_INVOICE_FAILURE, (state) => {
      state.loading = false
    })
})
